import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { focarMesaDiscadora, abrirMesaDiscadora } from "@/lib/discadoraMesa";
import { toast } from "sonner";

// ANTENA GLOBAL da ficha da discadora (Douglas 13/07): o consultor pode estar em QUALQUER
// tela do CRM — a ficha que chegar e gravada no MESMO cofre local (discadora_payload) que a
// pagina da Discadora le ao abrir. Quando ele voltar pra tela, a ficha esta la. Zero
// dessincronizacao por troca de tela. Nao renderiza nada; falha = silencio (nunca derruba).
export function DiscadoraFichaGlobal() {
  const { user } = useAuth();
  const uid = (user as any)?.id || null;

  useEffect(() => {
    if (!uid) return;
    const ch = supabase
      .channel(`discadora-ficha-global-${uid}`)
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table: "discadora_events", filter: `consultor_id=eq.${uid}` },
        (evt: any) => {
          try {
            const p = evt?.new?.payload ?? {};
            // 09/09: o motor despausou (pausa do Sucesso venceu). Em QUALQUER tela do CRM:
            // foca a Mesa se estiver aberta, abre se não estiver (janela nomeada — nunca
            // duplica). Se o navegador barrar o pop-up, avisa até ele clicar.
            if (p?.tipo === "voltou_para_fila") {
              const janela = abrirMesaDiscadora();
              if (!janela) {
                toast.warning("Você voltou para a fila da discadora", {
                  description: "A pausa do Sucesso terminou. Abra a Mesa para receber as ligações.",
                  duration: 120000,
                  action: { label: "Abrir Mesa", onClick: () => { abrirMesaDiscadora(); } },
                });
              }
              try {
                if ("Notification" in window && Notification.permission === "granted") {
                  const n = new Notification("Você voltou para a fila da discadora", { body: "A pausa do Sucesso terminou. As ligações vão cair na Mesa.", tag: "prime-voltou-fila" });
                  n.onclick = () => { abrirMesaDiscadora(); n.close(); };
                }
              } catch { /* notificação é reforço, nunca obrigatória */ }
              return;
            }
            if (p?.tipo === "ficha_encerrada") {
              const raw = localStorage.getItem("discadora_payload");
              if (!raw) return;
              const atual = JSON.parse(raw);
              const fp = p?.fingerprint ?? null;
              if (!fp || atual?.call_id === fp || atual?.fingerprint === fp) {
                atual._encerrada = true;
                atual._auto_tabulada = !!p?.auto_tabulada;
                atual._auto_tabulacao_id = p?.auto_tabulacao_id ?? null;
                atual._talk_ms = p?.talk_ms ?? null;
                localStorage.setItem("discadora_payload", JSON.stringify(atual));
              }
              return;
            }
            const dados = p?.dados_lead ?? {};
            const ficha: any = {
              call_id: p?.fingerprint ?? String(Date.now()),
              cliente_id: p?.cliente_id ?? null,
              consultor_id: p?.consultor_id ?? null,
              fingerprint: p?.fingerprint ?? null,
              timestamp: p?.timestamp ?? null,
              ...dados,
            };
            localStorage.setItem("discadora_payload", JSON.stringify(ficha));
            localStorage.setItem("discadora_payload_at", String(Date.now()));
            localStorage.setItem("discadora_payload_uid", uid);
            focarMesaDiscadora();
          } catch { /* antena nunca derruba nada */ }
        },
      )
      .subscribe();
    return () => { supabase.removeChannel(ch); };
  }, [uid]);

  return null;
}
